// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AdminUser {
  id: string;
  email: string | null;
  name: string | null;
  avatar_url: string | null;
}

/**
 * Hook to fetch list of admins from user_roles table
 */
export function useAdminList() {
  return useQuery({
    queryKey: ['admin-list'],
    queryFn: async () => {
      // First get admin user_ids from user_roles
      const { data: adminRoles, error: rolesError } = await supabase
        .from('user_roles')
        .select('user_id')
        .in('role', ['admin', 'rlevents_super_admin']);

      if (rolesError) throw rolesError;

      const adminUserIds = [...new Set(adminRoles?.map((r) => r.user_id).filter(Boolean) || [])];

      if (adminUserIds.length === 0) return [];

      // Then get profiles for those admins.
      // NOTE: profiles uses `user_id` (not `id`) as the reference to auth.users.
      const { data: profiles, error: profilesError } = await supabase
        .from('profiles')
        .select('user_id, email, name, avatar_url')
        .in('user_id', adminUserIds);

      if (profilesError) throw profilesError;

      // Map to the AdminUser shape expected by the UI (id = user_id)
      return (profiles || [])
        .map((p) => ({
          id: p.user_id,
          email: p.email,
          name: p.name,
          avatar_url: p.avatar_url,
        }))
        .filter((p) => p.id && p.id.trim() !== '') as AdminUser[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
